<template>
  <v-card tabindex="-1" @keydown.esc="$emit('close')" @keydown.enter="$emit('enter')">
    <v-layout column>
      <v-toolbar card  light dense flat>
      <v-toolbar-title>{{title}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-flex v-show="cxt.isFilterMode()" sm4 xs4 >
        <v-text-field
          autofocus
          label="Фильтр"
          v-show="cxt.isFilterMode()"
          v-model="cxt.filterString"
          v-on:input="onChangeFilter"
          solo flat
        ></v-text-field>
      </v-flex>
      <v-btn icon @click="cancel">
        <v-icon>close</v-icon>
      </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout row>
          <v-flex sm6 xs6>
            <v-layout column>
              <v-chips-field
                emptyChip="Контрагент"
                solo flat
                @remove="removeRef"
                @click="selectRef"
                :items="chipsItems"
                :chipSize="fullscreen ? 12 : 25" >
              </v-chips-field>
              <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
              <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
              </v-layout>
          </v-flex>
          <v-flex sm6 xs6>
            <v-select
              label="Папка"
              :value="path"
              v-on:input="onChangeFolder"
              @change="onChangeFolder"
              :hint="getDisplayPathByPath(getDepoCurrentPath)"
              :items="getDisplayPaths()"
              item-value="key"
              item-text="value"
            >
            <template slot="item" slot-scope="data">
              <span :style="styleItem(data.item)">{{data.item.value}}</span>
            </template>
            </v-select>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-scroll ref="cardScroll" flat :height="calcDialogScroll(48+100+52)" v-on:nextPage="nextPage">
      <v-list two-line dense>
        <template v-for="item in this.filteredItems">
          <v-subheader v-if="item.header" v-text="item.header"></v-subheader>
          <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
          <v-list-tile v-else v-bind:key="getItemKey(item)" @click="select(getItemKey(item))"  @keydown.space.prevent="select(getItemKey(item))" tabindex="0">
            <v-list-tile-avatar tile>
              <v-component :is="createPreview(item)"/>
            </v-list-tile-avatar>
             <v-list-tile-content>
              <v-list-tile-title><b>{{item.docName}}</b></v-list-tile-title>
              <v-list-tile-sub-title>{{item.uid}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon v-if="radio" v-show="cxt.check(getItemKey(item))">radio_button_checked</v-icon>
              <v-icon v-if="radio" v-show="cxt.uncheck(getItemKey(item))">radio_button_unchecked</v-icon>
              <v-icon v-if="!radio" v-show="cxt.check(getItemKey(item))">check_box</v-icon>
              <v-icon v-if="!radio" v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
            <v-list-tile-action-text>{{formats.blank(item.uploaded, formats.formatDate)}}</v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-scroll>
    <v-card-actions>
      <v-btn :disabled='cxt.selectedCount() === 0' @click="ok">ОК</v-btn>
      <v-btn @click="addFile()">Депонировать</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-show="cxt.selectedCount() === 0 && !radio" @click="cxt.checkAll()">Выбрать все</v-btn>
      <v-btn v-show="cxt.selectedCount() > 0" @click="cxt.clear()">Очистить</v-btn>
      <span tabindex="0" v-on:focus="firstFocus()"></span>
    </v-card-actions>
  </v-layout>
  </v-card>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import classes from '../../api/classes'
  import apimix from '../common/apimix'
  import vCardScroll from '../common/CardScroll'
  import vChipsField from '../common/ChipsField.vue'
  import client from '../client'
  import depo from '.'

  export default {
    name: 'doc-selector',
    components: {vCardScroll, vChipsField},
    mixins: [apimix],
    data: () => ({
      valid: false,
      path: '//root',
      chipsItems: [],
      cxt: null
    }),
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Выберите документ'
      },
      queryCxt: {
        type: Object,
        default: null
      },
      query: {
        type: String,
        default: null
      }
    },
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.filterMode = true
      cxt.mode = classes.modes.SELECT
      this.cxt = cxt
    },
    mounted () {
      this.cxt.filterString = this.query
      this.$store.dispatch('fetchDepoFolders')
      this.setQueryCxt(this.queryCxt)
      this.fetchData()
      this.setFocus()
    },
    watch: {
      queryCxt (newVal) {
        this.setQueryCxt(newVal)
      },
      getProfileHaveClient: function (newVal, oldVal) { // watch it
        if (newVal && !oldVal) {
          this.fetchData()
        }
      }
    },
    computed: {
      ...mapGetters({
        getProfileHaveClient: 'getProfileHaveClient',
        getDepoDisplayPaths: 'getDepoDisplayPaths',
        calcDialogScroll: 'calcDialogScroll',
        getDepoUrl: 'getDepoUrl',
        getItemSet: 'getDepoFileSet',
        getDepoCurrentPath: 'getDepoCurrentPath',
        getIsMobile: 'getIsMobile',
        getDepoConstant: 'getDepoConstant'
      }),
      items () {
        return this.getItemSet.getItems()
      },
      orderedItems () {
        return this.items
      },
      foldedItems () {
        let path = this.getDepoCurrentPath
        return this.orderedItems.filter(i => i.path === path)
      },
      tagedItems () {
        const getSearchString = (item) => {
          return ''.concat(item.tags)
        }
        var result = this.foldedItems
        let refs = this.getRefs(this.getTags())
        if (Array.isArray(refs)) {
          refs.forEach(tag => {
            var t = tag.toUpperCase()
            result = result.filter(item => getSearchString(item).toUpperCase().includes(t))
          })
        }
        return result
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.docName,
              item.fileName,
              item.tags,
              formats.formatDate(item.uploaded))
        }
        // var result = this.orderedItems
        var result = this.tagedItems

        if ((!this.cxt.isFilterMode()) || (this.cxt.filterString === null)) {
          return result
        }
        let terms = formats.parseSearchTerms(this.cxt.filterString)
        if (terms.length < 1) {
          return result
        }
        return result.filter(item => {
          let searchStr = getSearchString(item).toLowerCase()
          return terms.every(t => (searchStr.includes(t)))
        })
      },
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : ''
        } else {
          return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : ''
        }
      }
    },
    methods: {
      setFocus () {
        this.$nextTick(function () {
          if (!this.$el.contains(document.activeElement)) {
            this.$el.focus()
          }
        })
      },
      firstFocus () {
        let input = this.$el.querySelector('input')
        if (input) {
          input.focus()
        } else {
          this.$el.focus()
        }
      },
      changeFilterContext (ops, force) {
        this.$store.commit('setDepoFileSetFilterContext', Object.assign({}, this.getItemSet.getFilter(), ops))
        var self = this
        setTimeout(() => {
          self.$store.dispatch('fetchDepoFileSet', force)
          self.scrollToActive()
        }, 500)
      },
      onChangeFilter (e) {
        this.cxt.filterString = e
        if ((this.getProfileHaveClient)) {
          let search = formats.stringifySearchTerms(formats.parseSearchTerms(this.cxt.filterString))
          if (formats.compareString(search, this.getItemSet.getFilter().search) !== 0) {
            this.changeFilterContext({search: search}, true)
          }
        }
      },
      onChangeFolder (path) {
        this.changeFilterContext({path: path}, true)
      },
      getSortString () {
        switch (this.order) {
          case 'BY_NAME':
            return 'docName'
          case 'BY_UPLOADED':
            return 'uploaded,desc'
          default:
            return ''
        }
      },
      onChangeTags (v) {
        this.changeFilterContext({tags: v}, true)
      },
      onChangeSort (v) {
        this.$store.commit('setDepoFileSetSort', this.getSortString())
        this.changeFilterContext(null, true)
      },
      onChangeScope (v) {
        this.changeFilterContext({scope: v}, true)
      },
      fetchData (force) {
        if (this.getProfileHaveClient) {
          this.$store.commit('setDepoFileSetSort', this.getSortString())
          this.changeFilterContext({search: this.cxt.filterString, path: this.getDepoCurrentPath, tags: this.getTags(), scope: this.getDepoConstant.ALL_SCOPE}, force)
          this.fillRefChips(this.getRefs(this.getTags()))
        }
      },
      nextPage () {
        this.$store.commit('nextDepoFileSet')
        this.$store.dispatch('fetchDepoFileSet')
      },
      scrollToActive () {
        this.$nextTick(() => {
          this.$refs.cardScroll.scrollToListActive()
        })
      },
      ok () {
        this.$emit('input', this.cxt.selected())
        this.cancel()
      },
      cancel () {
        this.$emit('close')
        this.cxt.clear()
      },
      getItemKey (item) {
        return item.uid
      },
      getDisplayPaths () {
        var map = this.getDepoDisplayPaths
        var result = []
        if (!map) {
          return result
        }
        map.forEach((val, key) => result.push({key: key, value: val.substring(val.lastIndexOf('/') + 1), dpath: val}))
        return result.sort((a, b) => formats.compareString(a.dpath, b.dpath))
      },
      getDisplayPathByPath (path) {
        let dpath = this.getDepoDisplayPaths ? this.getDepoDisplayPaths.get(path) : ''
        return dpath.substring(0, dpath.lastIndexOf('/'))
      },
      styleItem (item) {
        var margin = item && item.key && item.key.replace(/(\/\/root)/, '').replace(/\d/g, '').length + 'em' || '0em'
        return 'margin-left: ' + margin
      },
      select (uid) {
        if (this.cxt.uncheck(uid)) {
          if (this.radio) {
            this.cxt.clear()
          }
        }
        this.cxt.select(uid)
      },
      addFile () {
        depo.newFile(this.path, null, null, this.tags.join(', '))
      },
      createPreview (item) {
        return depo.createPreview(item, this)
      },
      onRefChanged (refs) {
        let tags = refs.map(ref => `#${ref}`)
        this.onChangeTags(tags)
        this.fillRefChips(refs)
      },
      fillRefChips (refs) {
        const getHint = company => {
          return `${company.name} (ИНН: ${formats.formatInn(company.inn)})`
        }
        const getError = company => null
        const cb = (companies) => {
          console.log('fillRefChips', companies)
          let set = new Set(refs)
          let items = companies.map(c => {
            set.delete(c.ref)
            return {value: c.ref, text: c.caption, hint: getHint(c), error: getError(c)}
          })
          set.forEach(ref => items.push({value: ref + '', text: '#' + ref, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null}))
          this.chipsItems = items
        }
        client.getCachedRefs(refs, cb)
      },
      selectRef () {
        const onSelect = (companies) => {
          console.log('onSelect', companies)
          if (Array.isArray(companies)) {
            this.onRefChanged(companies.map(c => c.ref + '' || ''))
          }
        }
        client.selectRef(this, onSelect, () => {}, true, true)
      },
      removeRef (v) {
        this.onRefChanged([])
      },
      setQueryCxt (val) {
        if (val && val.path) {
          this.onChangeFolder(val.path)
        }
        if (val && val.inns) {
          this.onRefChanged(val.inns)
        }
      },
      getRefs (tags) {
        return tags.map(tag => tag.replace('#', ''))
      },
      getTags () {
        return this.getItemSet && this.getItemSet.getFilter().tags || []
      }
    }
  }

</script>




// WEBPACK FOOTER //
// DocSelector.vue?f352cfec